<template>
  <div>
    <v-btn
        absolute top left
        color="primary"
        class="white--text"
        @click="navigateBack()">
        <v-icon large>mdi-chevron-left</v-icon>
    </v-btn>

    <div
      class="text-center mb-4" 
      :class="$vuetify.breakpoint.xs ? 'text-h6 mt-4' : 'text-h5 mt-5'"
    >
        <v-icon :large="!$vuetify.breakpoint.xs">
            mdi-chart-line
        </v-icon>
        Egg Summary
    </div>  
    <v-data-table
        class="mt-5 mx-4"
        style="min-width: 1400px;"
        dense
        :headers="headers" 
        :items="filteredDataTableItems"
        item-key="key"
        :search="filterBy"
        multi-sort
        :items-per-page="15"
    >
      <template v-slot:top>
        <div class="mb-0 d-flex flex-wrap overflow-y-auto">
            <v-text-field
                v-model="farm"
                readonly
                class="mr-2"
                style="max-width: 102px;"
                label="Farm"
            />
             <v-text-field
                v-model="line"
                readonly
                class="mr-2"
                style="max-width: 102px;"
                label="Line"
            />
             <v-text-field
                v-model="minigen"
                readonly
                style="max-width: 102px;"
                class="mr-2"
                label="MG"
            />
             <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        :disabled="!isOnline"
                        fab
                        v-on="on"
                        small
                        class="mx-2 mt-3"
                        @click="showConfigDialog()">
                        <v-icon>mdi-cog</v-icon>
                    </v-btn>
                </template>
                <span>Report Config</span>
            </v-tooltip>
             <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        :disabled="!isOnline || !minigen"
                        fab
                        v-on="on"
                        small
                        class="mr-2 mt-3"
                        @click="loadReport()">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                </template>
                <span>Load Report</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        :disabled="!isOnline || !minigen"
                        fab
                        v-on="on"
                        small
                        class="mr-4 mt-3"
                        @click="downloadCsv()">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
                <span>Export To Excel</span>
            </v-tooltip>
            <v-text-field
                class="mt-1"
                style="max-width: 210px;"
                v-model="filterBy"
                clearable
                label="Search"
                type="text"
                prepend-icon="mdi-magnify"
            />
            <v-select
              class="ml-4 mt-1"
              v-model="category"
              label='Filter category'
              :items="['Pedigree', 'Super Sister']"
              style="max-width: 210px; margin-left: auto;"
            />
        </div>
      </template>

      <template v-slot:[`item.IsPedigree`]="{ item }">
        <div v-if="item.IsPedigree"><v-icon class="pl-4" color="green">mdi-check</v-icon></div>
        <div v-else><v-icon class="pl-4" color="red">mdi-cancel</v-icon></div>
      </template>
    </v-data-table>

    <v-dialog v-model="showConfigDialogFlag" persistent max-width="400">
      <v-card color="cardbackground">
        <v-card-title class="text-h5 mb-5"><v-icon class="mr-2">mdi-cog</v-icon>Report Configuration</v-card-title>
        <v-card-text class="d-flex">
            <v-select
                v-model="dialogFarm"
                class="mr-2"
                style="max-width: 102px;"
                label="Farm"
                 item-text="farmCode"
                 item-value="farmCode"
                :items="farms"
            />
             <v-select
                :disabled="!dialogFarm"
                v-model="dialogLine"
                class="mr-2"
                style="max-width: 102px;"
                label="Line"
                :items="farmLines"
            />
             <v-select
                :disabled="!dialogLine"
                v-model="dialogMinigen"
                style="max-width: 102px;"
                label="MG"
                :items="farmLineMgs"
            />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn large
            color="primary"
            class="white--text mb-2"
            :disabled="!dialogFarm || !dialogLine || !dialogMinigen"
            @click="loadReport(); closeConfigDialog();"
          >
            Load
          </v-btn>
          <v-btn
            large
            color="secondary"
            class="mb-2"
            @click="closeConfigDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isBusy">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
   </div>
</template>

<script>
import eggApi from '../../api/eggApi'
import fileApi from '../../api/fileApi'
import { mapState } from 'vuex'
import json2csv from "../../utils/json2csv"

export default {
  data() {
    return {
      category: "Pedigree",
      dataTableItems: [],
      filterBy: null,
      isBusy: false,
      farm: null,
      line: null,
      minigen: null,
      dialogFarm: null,
      dialogLine: null,
      dialogMinigen: null,
      allMgs: [],
      showConfigDialogFlag: false
    };
  },
  async created() {
      this.farm = this.settings.currentFarm;
      this.allMgs = await eggApi.getMiniGenList();
  },
  computed: {
    ...mapState(['settings','isOnline']),
    filteredDataTableItems: {
      get() {
        if (this.category === 'Pedigree') {
          return this.dataTableItems.filter(x => x.IsPedigree);
        }
        else {
          return this.dataTableItems.filter(x => !x.IsPedigree);
        }
      }
    }, 
    farms() {
        return this.settings.farms;
    },
    headers() {
      var hdrValues = [ 
        { text: 'Wingband', value: 'Wingband', sortable: true, width: '120px' },
        { text: 'Pedigree', value: 'IsPedigree', sortable: false, width: '80px'},
        { text: 'Last Collected', value: 'LastCollectionDate', sortable: true, width: '140px' },
        { text: 'House', value: 'HouseCode', sortable: true, width: '90px' },
        { text: 'Badge', value: 'BadgeCode', sortable: true, width: '100px' }
      ];
     
      if (this.filteredDataTableItems.length == 0) return hdrValues;
  
      for (var col in this.filteredDataTableItems[0]) {
        if (!["Mg", "BadgeCode", "HouseCode", "Wingband", "IsPedigree", "LastCollectionDate", "Settable", "Total"].includes(col)) {
            if(this.filteredDataTableItems.some(d => d[col] !== 0)){
            hdrValues.push({ text: col, value: col, sortable: true, align: 'center'});
        } 
        } 
      }

      hdrValues.push({ text: 'Settable', value: 'Settable', sortable: true, align: 'center'});
      hdrValues.push({ text: 'Total Eggs', value: 'Total', sortable: true, align: 'center'});

      return hdrValues;
      // return  [
      //   { text: 'Wingband', value: 'Wingband', sortable: true },
      //   { text: 'Pedigree', value: 'isPedigree', sortable: true,},
      //   { text: 'Last Collected', value: 'lastCollectionDate', sortable: true },
      //   { text: 'Good', value: 'good', sortable: true, align: 'center'},
      //   { text: 'Cracked', value: 'cracked', sortable: true, align: 'center' },
      //   { text: 'Dirty', value: 'dirty', sortable: true, align: 'center'},
      //   { text: 'Membrane', value: 'membrane', sortable: true, align: 'center' },
      //   { text: 'Total Eggs', value: 'total', sortable: true, align: 'center'}
      // ]
    },
    farmLines() {
        let lineList = this.allMgs
            .filter(m => m.farmCode === this.dialogFarm)
            .map(m => m.lineCode);
        let uniqueLines = [...new Set(lineList)];
        let lines = uniqueLines.map(l => (
            {
                text: `  L${l}`,
                value: l
            }
        ));
        return lines;
    },
    farmLineMgs() {
        let mgList = this.allMgs
            .filter(m => m.farmCode === this.dialogFarm && m.lineCode == this.dialogLine)
            .map(m => m.miniGenerationNum)
            .sort((a,b) => a < b ? 1:-1);
        let uniqueMgs = [...new Set(mgList)];
        let lines = uniqueMgs.map(l => (
            { 
                text: `  ${l}`,
                value: l
            }
        ));
        return lines;
    }
  },
  methods: {
    closeConfigDialog() {
      this.showConfigDialogFlag = false;
    },
    getGradeColor(grade) {
        switch (grade) {
            case 'GOOD': return 'green';
            case 'DIRTY': return '#e6e600';
            case 'MEMBRANE': return 'orange';
            case 'CRACKED': return 'red';
            default: return 'gray';
        }
    },
    getGradeDesc(grade) {
        let desc = grade.toLowerCase();
        desc = desc.charAt(0).toUpperCase() + desc.slice(1);

        return desc;
    },
    async loadReport() {
        try {
            this.isBusy = true;

            this.farm = this.dialogFarm;
            this.line = this.dialogLine;
            this.minigen = this.dialogMinigen;

            this.dataTableItems = await eggApi.getEggSummary(this.farm, this.line, this.minigen);
            this.isBusy = false;
        }
        catch(e) {
            this.isBusy = false;
            this.$root.showNoticeError(e);
        }
    },
    navigateBack() {
      this.$router.go(-1);
    },
    downloadCsv() {
      try {
        const nonZeroColumns = {};
        this.settings.eggGrades.forEach(g => {
          nonZeroColumns[g.descr] = this.filteredDataTableItems.some(item => item[g.descr] !== 0);
        });
        const items = this.filteredDataTableItems.map(x => {
          var column = {};
          column['Mg'] = x.Mg;
          column['Wingband'] = x.Wingband;
          column['Pedigree'] = x.IsPedigree;
          column['Last Collected'] = x.LastCollectionDate;
          column['House'] = x.HouseCode;
          column['Badge'] = x.BadgeCode;

          this.settings.eggGrades.forEach(g => {
            if (nonZeroColumns[g.descr]) {
                 column[g.descr] = x[g.descr];
              }
          });
          column['Settable'] = x.Settable;
          column['Total Eggs'] = x.Total;
          return column;
        });

        var csv = json2csv.convert(items);

        const fileName = `EggSummary-${this.farm}-L${this.line}-MG${this.minigen}.csv`;
        fileApi.downloadCsvLocal(fileName, csv);
      }
      catch (error) {
        this.$root.showNoticeError(error);
      }
    },
    showConfigDialog() {
      this.dialogFarm = this.farm;
      this.dialogLine = this.line;
      this.dialogMinigen = this.minigen;

      this.showConfigDialogFlag = true;
    }
  }
}
</script>